import React, { useEffect, useState } from 'react';
import { Button, Alert } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import { AmplifyUser } from '@aws-amplify/ui';
import { useNavigate } from 'react-router-dom';

import { Logo } from '../components/layout';

interface IProps {
    auth: (typeof Auth),
    user: AmplifyUser | null | undefined,
    authError?: any,
    setAuthError?: (error: any) => void
}

const SignIn = (props: IProps): JSX.Element => {

    const [loading, setLoading] = useState<boolean>(true);
    const [signInError, setSignInError] = useState<string | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        setLoading(props.user === undefined);
        if (props.user)
            navigate('/');
    }, [props.user, navigate]);

    const handleSignIn = async () => {
        setLoading(true);
        setSignInError(null);
        if (props.setAuthError) {
            props.setAuthError(null);
        }

        try {
            await props.auth.federatedSignIn({ customProvider: 'helseid' });
        } catch (error: any) {
            console.error('Sign in error:', error);
            setLoading(false);
            setSignInError(error.message || 'Failed to initiate sign in');
        }
    };

    return (
        <>
            <div className="App">
                <header className="App-header">
                </header>
                <div className='App-intro'>
                    <Logo />
                    {
                        loading &&
                        <p>Loading...</p>
                    }
                    {
                        !loading &&
                        <>
                            <p>
                                Hello guest!
                            </p>
                            {signInError && (
                                <Alert
                                    variation="error"
                                    isDismissible
                                    hasIcon
                                    heading="Sign In Error"
                                    style={{ marginBottom: '1rem' }}
                                >
                                    {signInError}
                                </Alert>
                            )}
                            {props.authError && (
                                <Alert
                                    variation="warning"
                                    hasIcon
                                    heading="Authentication Issue"
                                    style={{ marginBottom: '1rem' }}
                                >
                                    If you recently completed authentication but cannot access the application,
                                    your account may need to be activated. Please contact your administrator.
                                </Alert>
                            )}
                            <Button
                                variation="primary"
                                onClick={handleSignIn}
                                isLoading={loading}
                            >
                                Sign In
                            </Button>
                        </>
                    }
                </div>
            </div>
        </>
    );

}

export default SignIn;
